import { useEffect } from "react";

/** A one-line confirmation above the bottom bar that dismisses itself. */
export function Toast({ text, onDone }: { text: string; onDone: () => void }) {
  useEffect(() => {
    const t = setTimeout(onDone, 2600);
    return () => clearTimeout(t);
  }, [text, onDone]);
  return (
    <div
      role="status"
      className="fixed bottom-24 left-1/2 z-50 -translate-x-1/2 rounded-lg bg-neutral-100 px-3.5 py-2 text-sm font-semibold whitespace-nowrap text-ground shadow-lg sm:bottom-6"
    >
      {text}
    </div>
  );
}
